// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1_Gy9","inputDescription":"styles_inputDescription__337kc"};